<template>
  <div>
    <CDropdown
      toggler-text="Exportar a"
      class="m-2"
      color="secondary"
    >
      <CDropdownItem @click="exportarExcel">Excel</CDropdownItem>
      <CDropdownItem @click="exportarCsv">CSV</CDropdownItem>
      <CDropdownItem @click="exportarPdf">PDF</CDropdownItem>
    </CDropdown>
  </div>
</template>

<style scoped>
</style>

<script>
import { exportToExcel } from './exportExcel';
import { exportToCsv } from './exportCsv';
import { exportToPdf } from './exportPdf';

export default {
  name: "CustomExport",
  components: {},
  created() {},
  mounted() {},
  props: {
    lista: Array,
    fields: Array,
    name: String
  },
  data() {
    return {};
  },
  methods: {
    exportarExcel(){
      exportToExcel(this.lista, this.fields, this.name);
    },
    exportarCsv(){
      exportToCsv(this.lista, this.name, this.fields);
    },
    exportarPdf(){
      exportToPdf(this.lista, this.fields, this.name);
    }
  },
  beforeDestroy() {},
};
</script>
